const axios = require('axios');

export default

    class refoundController {

    constructor(resource) {
        this._resource = resource
    }

    getAll() {
        return this._resource("refound").get()
            .then(res => res.json())
    }

    createRefoundReceipt(data) {
        return this._resource("refound/receipt").save(data)
          .then(res => res.json())
    }

    update(data){
        return this._resource("refound").update(data)
            .then(res => res.body)
    }
}
